import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

export default function ProtectedRoute({ children, roles }) {
    const { user, loading } = useAuth();
    const location = useLocation();

    if (loading) {
        return <div className="min-h-[50vh] flex items-center justify-center font-mono text-muted-foreground">Se încarcă...</div>;
    }
    if (!user) {
        return <Navigate to={`/login?next=${encodeURIComponent(location.pathname + location.search)}`} replace />;
    }
    if (roles && !roles.includes(user.role)) {
        return <Navigate to="/" replace />;
    }
    return children;
}
